
export const ctaTranslations = {
  ctaTitle: {
    fr: "Vivez la Singularité : la Collective d’innovation la plus vivante d’Europe",
    en: "Experience Singularité: the most vibrant innovation Collective in Europe"
  },
  ctaSubtitle: {
    fr: "Rejoignez les sessions, inspirez, collaborez. Devenez un/une trailblazer de la Singularité",
    en: "Join the sessions, inspire, collaborate. Become a Singularité trailblazer"
  },
  ctaJoin: {
    fr: "Je demande à rejoindre Singularité.club",
    en: "I request to join Singularité.club"
  },
  ctaServices: {
    fr: "Voir le programme",
    en: "See the programme"
  },
};
